// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Vl_p","errorLogs":"EditorFooter_errorLogs__2XINg"};